import { Paper, Title } from '@mantine/core';

const FacilitySched = () => {
  return (
    <Paper p="xl" radius="md" w="100%">
      <Title order={3}>Facility Scheduler</Title>
      <p>Facility Scheduler content will be implemented here.</p>
    </Paper>
  );
};

export default FacilitySched;
